import React from 'react'
import { CHANGELOG } from '../../../content/changelog'

const ChangelogList = () => {
  const { releases, emptyMessage } = CHANGELOG

  if (!releases?.length) {
    return (
      <p className="changelog_empty" data-aos="fade-up" data-aos-duration={1500}>
        {emptyMessage}
      </p>
    )
  }

  return (
    <div className="changelog_entries">
      {releases.map((release) => (
        <article
          key={release.version}
          className="changelog_entry"
          data-aos="fade-up"
          data-aos-duration={1500}
        >
          <h2>
            {release.version}
            {release.title ? ` ${release.title}` : ''}
          </h2>
          {release.paragraphs?.map((paragraph, index) => (
            <p key={`${release.version}-p-${index}`}>{paragraph}</p>
          ))}
          {release.bullets?.length ? (
            <ul>
              {release.bullets.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          ) : null}
        </article>
      ))}
    </div>
  )
}

export default ChangelogList
